import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { InfoIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmailHTMLWarningDescription = ({
  prefixIcon
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "100",
    alignItems: "center",
    children: [prefixIcon, /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.emailHtml.filterWarning"
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      maxInlineSize: "320px",
      placement: "bottom",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.emailHtml.infoIcon.description"
      }),
      use: "longform",
      children: /*#__PURE__*/_jsx(InfoIcon, {
        color: "icon-core-subtle",
        size: "200"
      })
    })]
  });
};
export default EmailHTMLWarningDescription;